<div class="mt-n1 mb-4">
    <div class="nota-info warning">
        <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ titleByTipoSolicitud.plural }} no disponibles en el actual periodo. Debe desvincularlos de la solicitud para proceder al envío (Ir a pantalla {{ titleByTipoSolicitud.plural }}) </label>
    </div>
</div>

<app-codigoconfeccion-list *ngIf="esTipoAlmacenes"
    [mode]="recintoListMode" [readonly]="true" [result]="almacenes" [lastFilter]="lastFilterRecintos"
    (view)="onViewHandler($event)"></app-codigoconfeccion-list>

<!-- Ventana para mostrar el detalle de un Almacén -->
<app-codigoconfeccion-detail-dialog [visible]="recintoPIADetailVisible && esTipoAlmacenes" [Id]="recintoPIAIdSelected" (closed)="onRecintoDialogClosed($event)"></app-codigoconfeccion-detail-dialog>

<app-recinto-list *ngIf="esTipoRecintosPI" 
    [mode]="recintoListMode" [readonly]="true" [result]="recintosPI" [lastFilter]="lastFilterRecintos"
    (view)="onViewHandler($event)"></app-recinto-list>

<!-- Ventana para mostrar el detalle de un recinto PI y sus cultivos -->
<app-recinto-detail-dialog [visible]="recintoPIADetailVisible && esTipoRecintosPI" [Id]="recintoPIAIdSelected" [editMode]="false" (closed)="onRecintoDialogClosed($event)"></app-recinto-detail-dialog>


<app-empresadeshidratadora-list *ngIf="esTipoEmpresasDeshidratacion"
    [mode]="recintoListMode" [readonly]="true" [result]="empresasDeshidratacion" [lastFilter]="lastFilterRecintos"
    (view)="onViewHandler($event)"></app-empresadeshidratadora-list>

<!-- Ventana para mostrar el detalle de una Empresa Deshidratadora -->
<app-empresadeshidratadora-detail-dialog [visible]="recintoPIADetailVisible && esTipoEmpresasDeshidratacion" [Id]="recintoPIAIdSelected" (closed)="onRecintoDialogClosed($event)"></app-empresadeshidratadora-detail-dialog>